import { render, staticRenderFns } from "./ComplaintsChartBars.vue?vue&type=template&id=d0acf0b6&scoped=true"
import script from "./ComplaintsChartBars.vue?vue&type=script&lang=js"
export * from "./ComplaintsChartBars.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsChartBars.vue?vue&type=style&index=0&id=d0acf0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0acf0b6",
  null
  
)

export default component.exports